import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';

import type { W_Account_FindForNotifyAll_VM } from 'ab-api/web/account/findForNotifyAll';

import type UserGroupRequestModel from 'ab-requestModels/userGroup.requestModel';

import Checkbox from 'af-fields/Checkbox';
import MultiselectDropdown from 'af-fields/MultiselectDropdown';

import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';
import type { CredentialRecipientAccountFM, CredentialRecipientUserGroupFM } from '../formModel';

interface OwnProps {
	name: string;
	fieldName: string;
	userGroups: UserGroupRequestModel[];
	users: W_Account_FindForNotifyAll_VM['rows'];
}

type Props = OwnProps;

const renderUserGroupOption = (option: UserGroupRequestModel) => {
	return (
		<div>
			{option.name}
		</div>
	);
};

const renderUserGroupSelected = (selected: CredentialRecipientUserGroupFM[]) => {
	if (selected.length === 0) {
		return <div>None</div>;
	}

	const text = selected.map((_group) => _group.name).join(', ');
	return (
		<Tooltip
			containerClassName={styles.ellipsis}
			message={text}
			placement="top"
		>
			{text}
		</Tooltip>
	);
};

const renderUserOption = (option: W_Account_FindForNotifyAll_VM['rows'][0]) => {
	return (
		<div>
			{option.fullName}
		</div>
	);
};

const renderUserSelected = (selected: CredentialRecipientAccountFM[]) => {
	if (selected.length === 0) {
		return <div>None</div>;
	}

	const text = selected.map((_account) => _account.fullName).join(', ');
	return (
		<Tooltip
			containerClassName={styles.ellipsis}
			message={text}
			placement="top"
		>
			{text}
		</Tooltip>
	);
};

const Credential: React.FC<Props> = (props) => {
	const { name, fieldName, userGroups, users } = props;

	const userOptions = React.useMemo(() => {
		return users.map((_user) => ({
			..._user,
			disabled: !_user.email,
		}));
	}, [users]);

	return (
		<Row className={`row--padded-top p-l-0 ${styles['credential-row-container']}`}>
			<Col sm={8}>
				<Field
					component={Checkbox}
					inline={true}
					isStandalone={true}
					label={name}
					name={`${fieldName}.isEnabled`}
					type="text"
				/>
			</Col>
			<Col sm={8}>
				<Field
					component={MultiselectDropdown}
					fixed={true}
					isStandalone={true}
					label="To"
					name={`${fieldName}.userGroupRecipients`}
					options={userGroups}
					placeholder="User Groups"
					renderMenuItem={renderUserGroupOption}
					renderSelected={renderUserGroupSelected}
					valueKey="id"
				/>
			</Col>
			<Col sm={8}>
				<Field
					component={MultiselectDropdown}
					filterable={true}
					filterBy={['fullName']}
					fixed={true}
					isMultiselect={true}
					isStandalone={true}
					label="To"
					name={`${fieldName}.accountRecipients`}
					options={userOptions}
					placeholder="Users"
					renderMenuItem={renderUserOption}
					renderSelected={renderUserSelected}
					valueKey="id"
				/>
			</Col>
		</Row>
	);
};

export default React.memo(Credential);
